export const DataLayer = () => {
  return {
    getDataLayer() {
      window.dataLayer = window.dataLayer || [];
      return window.dataLayer;
    },
    push(params: Object) {
      this.getDataLayer().push(params);
    }
  };
}
